import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "我的待办", -1);
const _hoisted_2 = {
  style: {
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_table_page = _resolveComponent("table-page");
  const _component_record_representation_detail = _resolveComponent("record-representation-detail");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_drawer = _resolveComponent("el-drawer");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, null, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.flow.flowApi.myTaskList,
    columns: $data.columns,
    selectionEnable: false,
    searchItems: $data.searchItems,
    linkButtons: $data.linkButtons,
    ref: "tablePage"
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["fetchApi", "columns", "searchItems", "linkButtons"]), _createVNode(_component_el_drawer, {
    modelValue: $data.recordDetailDrawer,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.recordDetailDrawer = $event),
    title: "骑行记录申述单详情",
    direction: "rtl",
    size: "50%",
    "with-header": false,
    "close-on-click-modal": false,
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = () => this.recordDetailDrawer = false),
      type: "primary",
      plain: ""
    }, {
      default: _withCtx(() => [_createTextVNode("关闭")]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_record_representation_detail, {
      currentId: $data.businessKey,
      onAuditComplete: $options.recordAuditComplete
    }, null, 8, ["currentId", "onAuditComplete"])]),
    _: 1
  }, 8, ["modelValue"])]);
}